import { PageHeader, Result } from '@bookora/ui';

import { LinkButton } from '@/components/link-button';

import type { SectionDef } from './sections';

/**
 * What a `'pending'` section renders.
 *
 * ── WHY THIS EXISTS ─────────────────────────────────────────────────────────
 *
 * The route table covers every planned section so a deep link, a bookmark or a
 * notification `link` resolves to an explanation instead of a 404. Nothing in
 * the panel LINKS here — the sidebar omits pending sections entirely — so this
 * screen is only ever reached by typing or by an old bookmark, and it is
 * honest about why it is empty rather than pretending to be a feature.
 *
 * When the screen is built, `SECTIONS` flips the entry to `'ready'` with a
 * `load()` and this component stops being reachable for it.
 */
export function SectionPlaceholder({ section }: { section: SectionDef }) {
  return (
    <>
      <PageHeader title={section.label} description={section.description} />
      <Result
        status="info"
        title="این بخش هنوز فعال نشده"
        subTitle="وقتی این بخش راه‌اندازی بشه، در همین نشانی باز می‌شه. تا اون زمان، کارهای روزانه از داشبورد در دسترس است."
        extra={
          <LinkButton type="primary" to="/">
            بازگشت به داشبورد
          </LinkButton>
        }
      />
    </>
  );
}
